import Navbar from "@/pages/home/components/Navbar";
import PageBanner from "@/pages/home/components/PageBanner";
import Features from "@/pages/home/components/Features";
import Footer from "@/pages/home/components/Footer";
import CmsPage from "@/components/cms/CmsPage";

export default function ResortPage() {
  return (
    <main className="w-full">
      <Navbar />
      <CmsPage slug="resort" path="/resort" fallbackSeo={{ title: "The Resort | NOMADLIVINGS", description: "Resort living elevated — every villa sits within a professionally managed resort environment with premium amenities." }}>
      <PageBanner
        eyebrow="The Resort"
        title="Resort Living,"
        highlight="Elevated to Perfection"
        subtitle="Every villa sits within a professionally managed resort environment, pairing premium amenities with effortless ownership from day one."
        image="https://readdy.ai/api/search-image?query=Luxury%20resort%20property%20with%20landscaped%20gardens%2C%20pools%20and%20modern%20A-frame%20villas%20on%20a%20hillside%20at%20golden%20hour%2C%20aerial%20elevated%20view%2C%20warm%20green%20and%20amber%20tones%2C%20premium%20hospitality%20real%20estate%20photography&width=1800&height=900&seq=banner-resort-x2&orientation=landscape&nocache=true"
        imageAlt="Luxury resort with A-frame villas on a hillside at golden hour"
        ctaLabel="Explore Investments"
        ctaTo="/investments"
      />
      <Features />
      </CmsPage>
      <Footer />
    </main>
  );
}